import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useContent } from "@/lib/content";

// Kanonische Domain der Live-Website – hier werden alle URLs für Google verankert
const SITE_BASE = "https://lacontadina-dresden.de";

function setMeta(key, content, attr = "name") {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setJsonLd(obj) {
  let el = document.getElementById("ld-restaurant");
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = "ld-restaurant";
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(obj);
}

export function Seo({ page }) {
  const c = useContent();
  const { pathname } = useLocation();
  const seo = c.seo?.[page] || {};
  const title = seo.title;
  const description = seo.description;

  useEffect(() => {
    const cleanPath = pathname.length > 1 && pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
    const canonical = SITE_BASE + (cleanPath === "/" ? "/" : cleanPath);

    if (title) document.title = title;
    setMeta("description", description);
    setCanonical(canonical);
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    setMeta("og:type", "website", "property");
    setMeta("og:url", canonical, "property");
    setMeta("og:image", c.brand?.logo, "property");
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);

    if (page === "home") {
      setJsonLd({
        "@context": "https://schema.org",
        "@type": "Restaurant",
        name: "La Contadina",
        image: c.brand?.logo,
        url: SITE_BASE + "/",
        telephone: c.brand?.phone,
        priceRange: "€€",
        servesCuisine: "Italienisch",
        address: {
          "@type": "PostalAddress",
          streetAddress: "Reisewitzer Str. 49",
          postalCode: "01159",
          addressLocality: "Dresden",
          addressCountry: "DE",
        },
        acceptsReservations: true,
      });
    }
  }, [title, description, pathname, page, c.brand]);

  return null;
}
